import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InventoryCard } from '@deckplan.io/common/inventory';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import * as qs from 'qs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { Pagination } from '@deckplan.io/common/records';
import { Query } from '@deckplan.io/common/filters';
import { Mockable } from '../mocks/mockable.decorator';

export interface QueryOptions {
    pagination: Partial<Pagination>;
    query: Query;
}

export interface InventoryCardsAndTotalCount {
    totalCount: number;
    inventoryCards: InventoryCard[];
}

@Injectable({
    providedIn: 'root'
})
@Mockable
export class InventoryService {

    constructor(private readonly http: HttpClient, private readonly authService: AuthService) {}

    public static getPrefix(userId: number): string {
        return `users/${userId}/inventory`;
    }

    // http://localhost:8080/v1/user/1/inventory?pageNumber=0&pageSize=10&sortOn=name&dir=ASC
    public getInventory(queryOptions: QueryOptions, userId: number = null): Observable<InventoryCardsAndTotalCount> {
        const currentUser = this.authService.currentUserValue;
        userId = (userId === null || !currentUser.isAdmin) ? currentUser.id : userId;
        let url = `${environment.apiUrl}/${environment.apiVersion}/${InventoryService.getPrefix(userId)}?pagination=${encodeURIComponent(qs.stringify(queryOptions.pagination))}`;

        if (queryOptions.query) {
            url += '&filter=' + encodeURIComponent(qs.stringify(queryOptions.query));
        }

        return this.http.get(url, {observe: 'response'})
            .pipe(
                map(res => ({totalCount: parseInt(res.headers.get('total-count'), 10), inventoryCards: res.body as any}))
            );
    }

    public addToInventory(inventoryCards: InventoryCard[], userId: number = null): Observable<InventoryCard[]> {
        const currentUser = this.authService.currentUserValue;
        userId = (userId === null || !currentUser.isAdmin) ? currentUser.id : userId;
        return this.http.post<InventoryCard[]>(`${environment.apiUrl}/${environment.apiVersion}/${InventoryService.getPrefix(userId)}`, inventoryCards);
    }

    public updateInventory(inventoryCard: InventoryCard, userId: number = null): Observable<InventoryCard> {
        const currentUser = this.authService.currentUserValue;
        userId = (userId === null || !currentUser.isAdmin) ? currentUser.id : userId;
        return this.http.put<InventoryCard>(`${environment.apiUrl}/${environment.apiVersion}/${InventoryService.getPrefix(userId)}/${inventoryCard.inventoryId}`, inventoryCard);
    }

    public removeInventory(inventoryCard: InventoryCard, userId: number = null): Observable<InventoryCard> {
        const currentUser = this.authService.currentUserValue;
        userId = (userId === null || !currentUser.isAdmin) ? currentUser.id : userId;
        return this.http.delete<InventoryCard>(`${environment.apiUrl}/${environment.apiVersion}/${InventoryService.getPrefix(userId)}/${inventoryCard.inventoryId}`);
    }

    public createExport(userId: number = null): Observable<{ exportString: string }> {
        const currentUser = this.authService.currentUserValue;
        userId = (userId === null || !currentUser.isAdmin) ? currentUser.id : userId;
        return this.http.get<{ exportString: string }>(`${environment.apiUrl}/${environment.apiVersion}/${InventoryService.getPrefix(userId)}/export`);
    }
}
